import React from 'react';
import CheckBox from '../../../components/form_components/CheckBox.react';

const ModeToggle = ({ selected, label, onCheck, onUncheck }) => (
  <div className='mode-check-div'>
    <CheckBox
      label={label}
      selected={selected}
      onCheck={onCheck}
      onUncheck={onUncheck}
      buttonWidth={32}
      buttonHeight={32}
    />
  </div>
);

export default ModeToggle;
